// Player identity + access-log session tracking.
// A session starts when the player confirms their name on the opening
// screen; duration is reported via periodic pings and a final beacon.
const API = process.env.REACT_APP_BACKEND_URL;
const NAME_KEY = "socher_hayam_player_v1";

let sessionId = null;
let games = 0;
let best = 0;
let pingTimer = null;

export function getPlayerName() {
  try {
    return localStorage.getItem(NAME_KEY) || "";
  } catch (e) {
    console.warn("failed to read player name", e);
    return "";
  }
}

export function setPlayerName(name) {
  try {
    localStorage.setItem(NAME_KEY, name);
  } catch (e) {
    console.warn("failed to persist player name", e);
  }
}

function deviceInfo() {
  const ua = navigator.userAgent;
  let os = "אחר";
  if (/Android/i.test(ua)) os = "Android";
  else if (/iPhone|iPad|iPod/i.test(ua)) os = "iOS";
  else if (/Windows/i.test(ua)) os = "Windows";
  else if (/Mac/i.test(ua)) os = "Mac";
  else if (/Linux/i.test(ua)) os = "Linux";
  let br = "אחר";
  if (/Edg\//.test(ua)) br = "Edge";
  else if (/Chrome\//.test(ua)) br = "Chrome";
  else if (/Firefox\//.test(ua)) br = "Firefox";
  else if (/Safari\//.test(ua)) br = "Safari";
  const kind = /Mobi|Android|iPhone|iPad/i.test(ua) ? "נייד" : "מחשב";
  return `${kind} · ${os} · ${br}`;
}

function ping(useBeacon) {
  if (!sessionId) return;
  const payload = JSON.stringify({
    session_id: sessionId,
    games_played: games,
    best_score: best,
  });
  const url = `${API}/api/sessions/ping`;
  if (useBeacon && navigator.sendBeacon) {
    navigator.sendBeacon(url, new Blob([payload], { type: "application/json" }));
  } else {
    fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: payload,
      keepalive: true,
    }).catch(() => {});
  }
}

export async function startSession(name) {
  try {
    const res = await fetch(`${API}/api/sessions/start`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        name,
        device: deviceInfo(),
        screen: `${window.screen.width}x${window.screen.height}`,
      }),
    });
    if (!res.ok) {
      console.warn("session start rejected", res.status);
      return;
    }
    const data = await res.json();
    sessionId = data.session_id;
  } catch (e) {
    console.warn("session start failed", e);
    return;
  }
  if (pingTimer) clearInterval(pingTimer);
  pingTimer = setInterval(() => ping(false), 30000);
  window.addEventListener("pagehide", () => ping(true));
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") ping(true);
  });
}

export function recordGame() {
  games += 1;
  ping(false);
}

export function recordScore(score) {
  if (score > best) best = score;
  ping(false);
}
